/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="94.95"
        height="95.43"
        viewBox="0 0 94.95 95.43"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M9.94 9.94a33.94 33.94 0 1 0 48.39.4l-.39-.4a34 34 0 0 0-48 0Zm46.23 1.77a31.18 31.18 0 1 1-.37-.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M9.94 9.94a33.94 33.94 0 1 0 48.39.4l-.39-.4a34 34 0 0 0-48 0Zm46.23 1.77a31.18 31.18 0 1 1-.37-.37Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M32.57 6.73a27.25 27.25 0 0 1 28.58 25.84A1.27 1.27 0 0 1 60 33.89a1.25 1.25 0 0 1-1.31-1.19 24.75 24.75 0 0 0-45.55-12.2A1.26 1.26 0 0 1 11 19.17 27.22 27.22 0 0 1 32.57 6.73Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="m93.7 86.04-8.14 8.14-25.6-25.61 8.13-8.13 25.61 25.6z"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="m67.21 59.55-8.14 8.14a1.26 1.26 0 0 0 0 1.76l25.61 25.61a1.25 1.25 0 0 0 1.77 0l8.13-8.13a1.25 1.25 0 0 0 0-1.77L69 59.55a1.27 1.27 0 0 0-1.79 0Zm.88 2.66 23.84 23.83-6.37 6.37-23.83-23.84Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="m57.29 57.77 6.26 6.26"/>
        <path
          fill="#0e497b"
          d="m59.77 55.3 6.25 6.25-4.95 4.95-6.25-6.25 4.95-4.95z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'MagnifyingGlassIcon';

export default Icon;
